import React from 'react';
import { useState, useEffect } from "react";
import Menu from '../../components/Menu/Menu';
import './Providers.scss';
import Header from '../../components/Header/Header';
import MobileMenu from "../../components/Menu/MobileMenu";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import MobileBottomMenu from "../../components/MobileBottomMenu/MobileBottomMenu";
import { Table, Switch, Tag, Dropdown, Menu as TableMenu, Button, Input } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { providersService } from "../../services/ProvidersService";

const Providers = () => {
  const [dataSource, setDataSource] = useState([
    {
      key: '1',
      numeFurnizor: 'SC Exemplu SRL',
      tipFurnizor: 'Firmă',
      tipServiciu: 'Transport',
      participa: true,
      produse: '5 produse',
      ziComanda: 'Luni',
    },
  ]);
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({});
  const dayMap = {
    monday: 'Luni',
    tuesday: 'Marți',
    wednesday: 'Miercuri',
    thursday: 'Joi',
    friday: 'Vineri',
    any: 'Oricare'
  };

  const reverseDayMap = Object.fromEntries(
    Object.entries(dayMap).map(([en, ro]) => [ro, en])
  );
  const [providers, setProviders] = useState([]);
  useEffect(() => {
    fetchProviders();
  }, [navigate]);

  const fetchProviders = (page = 1, search = '') => {
    providersService.getProviders(page, search)
      .then(response => {
        if (response.status === 401) {
          navigate("/login");
        } else {
          setProviders(response.data.suppliers);
          setPagination(response.data.pagination);
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        } else {
          console.error('Error fetching data:', error);
        }
      });
  };
  const handleOrderDayChange = (value, record) => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => item.key === record.key);
    if (index > -1) {
      newData[index].order_day = value;
      setDataSource(newData);
    }
  };
  const handleSwitchChange = (checked, record) => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => item.key === record.key);
    newData[index].participa = checked;
    setDataSource(newData);
  };

  const columns = [
    {
      title: 'Nume furnizor',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'CUI',
      dataIndex: 'cui',
      key: 'cui',
      width: 120,
      render: (value) => (value === null || value === undefined || value === '') ? '-' : value
    },
    {
      title: 'Tip furnizor',
      dataIndex: 'entity_type',
      key: 'entity_type',
      render: (value) => value === 'company' ? 'Firmă' : 'Persoană fizică'
    },
    {
      title: 'Tip serviciu',
      dataIndex: 'service_type',
      key: 'service_type',
    },
    {
      title: 'Participă la ofertare',
      dataIndex: 'participates_in_offering',
      key: 'participates_in_offering',
      render: (value) => value ? 'Da' : 'Nu'

    },
    {
      title: 'Produse atribuite',
      key: 'produse',
      width: 150,
      render: (_, record) => {
        if (!record.product_attributions || record.product_attributions.length === 0) {
          return '-';
        }
        return record.product_attributions.map(attr => (
          <Tag key={attr.id}>{attr.product?.name}</Tag>
        ));
      }
    },
    {
      title: 'Zi comandă',
      dataIndex: 'order_day',
      key: 'order_day'
    },
    {
      title: 'Acțiuni',
      key: 'actiuni',
      render: (_, record) => {
        const menu = (
          <TableMenu>
            <TableMenu.Item key="detalii" onClick={() => navigate(`/adauga-furnizor/${record.id}`)}>Detalii furnizor</TableMenu.Item>
            <TableMenu.Item key="sterge" danger>Sterge furnizor</TableMenu.Item>
          </TableMenu>
        );

        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button type="text" icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];
  return (
    <div className='standard products list providers'>
      <Header />
      <div className='standard__mobile-header'>
        <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
        <MobileMenu />
      </div>

      <div className='standard__container'>
        <Menu />
        <div className='standard__wrapper'>
          <div style={{ padding: 24, minHeight: 280 }}>
            <h2 className='standard__page-title'>Furnizori</h2>
            <h4 className='standard__page-info'>
              Aici gasesti informațiile necesare despre furnizori.
            </h4>

            <div className="list__table-wrapper providers__table-wrapper">

              <div className='list__table-content'>
                <Table
                  columns={columns}
                  dataSource={providers}
                  pagination={{
                    current: pagination.current_page,
                    pageSize: pagination.per_page,
                    total: pagination.total_entries,
                    onChange: (page) => fetchProviders(page),
                    showSizeChanger: false,
                    showLessItems: true,
                    position: ['bottomCenter']
                  }}
                />
              </div>
            </div>


          </div>
        </div>
      </div>
      <MobileBottomMenu/>
    </div>
  );
};

export default Providers;